import React from 'react';

import { DialogTitle } from '@headlessui/react';
import useAppContext from 'flow/hooks/useAppContext';
import reactStringReplace from 'react-string-replace';

interface Props {
    transferContactInfo: string;
    callerContactInfo: string;
}

const TransferTitleItem = ({
    transferContactInfo,
    callerContactInfo,
}: Props) => {
    const { i18next } = useAppContext();

    const unStyledSubTitle = i18next.t('General.Call.Transfer.Alert.Subtitle', {
        callerInfo: callerContactInfo,
        transferInfo: transferContactInfo,
    });
    const styledSubTitle = styleTextWithBoldWords(
        unStyledSubTitle,
        callerContactInfo,
        transferContactInfo,
    );

    return (
        <DialogTitle>
            <div className="mb-3 text-lg font-bold">
                {i18next.t('General.Call.Transfer.Alert.Title')}
            </div>
            <div className="mb-2">{styledSubTitle}</div>
        </DialogTitle>
    );
};

const styleTextWithBoldWords = (
    textToStyle: string,
    callerContactInfo: string,
    transferContactInfo: string,
) => {
    const boldCallerContactInfo = reactStringReplace(
        textToStyle,
        callerContactInfo,
        (match, i) => (
            <span key={match + i} className="bold">
                {match}
            </span>
        ),
    );
    const boldCallerAndTransferContactInfo = reactStringReplace(
        boldCallerContactInfo,
        transferContactInfo,
        (match, i) => (
            <span key={match + i} data-X={match} className="bold">
                {match}
            </span>
        ),
    );
    return boldCallerAndTransferContactInfo;
};

export default React.memo(TransferTitleItem);
